function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.001,
    height: 57,
    viewBox: "0 0 78.001 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_144",
    "data-name": "Vrstva 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_159",
    d: "M68.69 4H10.31A10.5 10.5 0 0 0 1 14.5v35A10.5 10.5 0 0 0 11.5 60h56A10.5 10.5 0 0 0 78 49.5v-35A10.5 10.5 0 0 0 68.69 4zm-1.61 7L43 35.08a3.5 3.5 0 0 1-4.935 0L13.985 11zM71 49.5a3.5 3.5 0 0 1-3.5 3.5h-56A3.5 3.5 0 0 1 8 49.5V15.935l24.08 24.08a10.5 10.5 0 0 0 14.84 0L71 15.935z",
    "data-name": "Trazado 159",
    transform: "translate(-1 -4)",
    style: {
      fill: "#3f66b3",
      stroke: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db34d52a39b180871d99203a035ee5a4.svg";
export { ForwardRef as ReactComponent };